import { type LinkComponent, createLink } from '@tanstack/react-router';
import { Link, type LinkSize, type LinkType, type LinkProps as RouterLinkProps } from '@vizit/atoms';

const TanstackLink = createLink(Link);

/**
 * A link component that uses the Tanstack Router Link component but maintains the Vizit theme.
 * @param {RouterLinkProps} props - The props of the link.
 * @example
 * <RouterLink to="/">
 *   Link Text
 * </RouterLink>
 */
const RouterLink: LinkComponent<typeof Link> = (props) => {
  return <TanstackLink preload={'intent'} {...props} />;
};

export { RouterLink };
export type { RouterLinkProps, LinkType as RouterLinkType, LinkSize as RouterLinkSize };
